var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('react-button',{attrs:{"isReacted":_vm.user.meta.isFollowed,"name":'Trust',"icon":'user-check'},on:{"toggleOn":function($event){_vm.followUser()},"toggleOff":function($event){_vm.unfollowUser()}}})}
var staticRenderFns = []

export { render, staticRenderFns }